import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiHeart,FiUsers,FiExternalLink,FiArrowRight}=FiIcons;

const ScamAssistance=()=> {
  return (
    <section className="py-20 bg-gray-800">
      <div className="container mx-auto px-6">
        <motion.div 
          className="max-w-4xl mx-auto text-center"
          initial={{opacity: 0,y: 50}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <div className="bg-gradient-to-br from-purple-900 to-gray-900 p-12 rounded-3xl border border-purple-500/30 relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-pink-500/10 rounded-full -translate-y-16 translate-x-16"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-cyan-400/10 rounded-full translate-y-12 -translate-x-12"></div>
            
            <motion.div
              initial={{opacity: 0,scale: 0.8}}
              whileInView={{opacity: 1,scale: 1}}
              transition={{delay: 0.2,duration: 0.6}}
              viewport={{once: true}}
            >
              <div className="bg-gradient-to-br from-pink-500 to-purple-600 p-4 rounded-full w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                <SafeIcon icon={FiHeart} className="text-3xl text-white" />
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-pink-500 to-cyan-400 bg-clip-text text-transparent">
                Think You've Been Scammed?
              </h2>
              <p className="text-xl text-gray-300 mb-6 leading-relaxed">
                You're not alone. Linda has partnered with the <strong className="text-white">AVAH Outreach Group</strong> to provide compassionate scam recovery support,resources,and education for victims and their families.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 text-left">
                <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                  <SafeIcon icon={FiUsers} className="text-2xl text-pink-500 mb-3" />
                  <h3 className="font-bold text-white mb-2">Support Groups</h3>
                  <p className="text-gray-400 text-sm">Connect with others who understand your experience</p>
                </div>
                
                <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                  <SafeIcon icon={FiHeart} className="text-2xl text-purple-500 mb-3" />
                  <h3 className="font-bold text-white mb-2">Recovery Resources</h3>
                  <p className="text-gray-400 text-sm">Practical steps to protect yourself moving forward</p>
                </div>
                
                <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                  <SafeIcon icon={FiUsers} className="text-2xl text-cyan-500 mb-3" />
                  <h3 className="font-bold text-white mb-2">Educational Programs</h3>
                  <p className="text-gray-400 text-sm">Learn to spot and avoid future scam attempts</p>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link 
                  to="/scam-assistance" 
                  className="group bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3 shadow-lg"
                >
                  <SafeIcon icon={FiHeart} className="text-xl group-hover:animate-pulse" />
                  Get Help Now
                </Link>
                
                <a 
                  href="https://avahoutreach.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="group bg-transparent border-2 border-cyan-400 hover:bg-cyan-400 hover:text-gray-900 text-cyan-400 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3"
                >
                  <SafeIcon icon={FiExternalLink} className="text-xl group-hover:rotate-12 transition-transform" />
                  AVAH Website
                </a>
              </div>
              
              <p className="text-sm text-gray-400 mt-4">
                Confidential • Free • No judgment — just support and understanding
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ScamAssistance;